import * as React from "react";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { Urls } from "../../../../../Urls";
import { adviserParse, IReviewProps, ongoingAdviceParse, regularAdviceParse } from "../ReviewParser";
import { NewQuoteAction } from "../../../NewQuoteWizard/Actions/NewQuoteAction";

export const AdviceChargeReview = (props: IReviewProps) => {
    const { data, subAccountType, process } = props;
    const checkNoneCharges = (config) => {
        return typeof config.data != "boolean";
    };
    const adviceCahrgeConfig = () => {
        if (!data) {return [];}
        const config = [
            {
                title: "Initial",
                data: adviserParse(data.InitialAdviserCharge),
            },
            {
                title: "Regular",
                data: regularAdviceParse(data.RegularPaymentInitialAdviceCharge),
            },
            {
                title: "Ongoing",
                data: ongoingAdviceParse(data.OngoingAdviceCharge),
            },
        ];
        return config.filter(checkNoneCharges);
    };

    const navigate = () => {
        if (process == ProcessType.NB) {
            Navigator.navigateToAndPreserveQueryParameters(adviceChargeUrlConfig());
        } else if (process == ProcessType.Quote) {
            adviceChargeUrlConfigForNewQuote();
        } else if (process == ProcessType.SinglePayment) {
            Navigator.navigateToAndPreserveQueryParameters(Urls.get().SPTAdviserCharge);
        }else if (process == ProcessType.AddRegular || ProcessType.EditRegular) {
            Navigator.navigateToAndPreserveQueryParameters(Urls.get().RegularPaymentAdviserCharge);
        }
    };

    const adviceChargeUrlConfigForNewQuote = () => {
        switch (subAccountType) {
            case SubAccountType.InvestmentAccount:
                return NewQuoteAction.copyQuoteInstruction(Urls.get().QuoteAdviserChargesPP);
            case SubAccountType.StocksIsa:
                return NewQuoteAction.copyQuoteInstruction(Urls.get().QuoteAdviserChargesISA);
            case SubAccountType.Pension:
            case SubAccountType.Sipp:
            case SubAccountType.Npr:
                return NewQuoteAction.copyQuoteInstruction(Urls.get().QuoteAdviserChargesSIPP);
            default:
                break;
        }
    };

    const adviceChargeUrlConfig = () => {
        switch (subAccountType) {
            case SubAccountType.StocksIsa:
                return Urls.get().NBAdviserChargesISA;
            case SubAccountType.InvestmentAccount:
                return Urls.get().NBAdviserChargesPP;
            case SubAccountType.Npr:
                return Urls.get().NBAdviserChargesSIPP;
            default:
                break;
        }
    };

    return (
        <Accordion label="Adviser charges" isOpen={false} onEdit={() => (props.onEditAction ? props.onEditAction() : navigate())}>
            <div className="pl-34">
                <Typography type="common" config={adviceCahrgeConfig()}></Typography>
            </div>
        </Accordion>
    );
};
